export const LOGIN_BEGIN = "app/App/LOGIN_BEGIN";
export const LOGIN_SUCCESS = "app/App/LOGIN_SUCCESS";
export const LOGIN_ERROR = "app/App/LOGIN_ERROR";

export const LOGOUT_BEGIN = "app/App/LOGOUT_BEGIN";
export const LOGOUT_SUCCESS = "app/App/LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "app/App/LOGOUT_ERROR";

export const FETCH_USER_DATA_BEGIN = "app/App/FETCH_USER_DATA_BEGIN";
export const FETCH_USER_DATA_SUCCESS = "app/App/FETCH_USER_DATA_SUCCESS";
export const FETCH_USER_DATA_ERROR = "app/App/FETCH_USER_DATA_ERROR";

export const SET_USER_DATA = "app/App/SET_USER_DATA";

export const SSO_LOGIN_BEGIN = "app/App/SSO_LOGIN_BEGIN";
export const SSO_LINK_BEGIN = "app/App/SSO_LINK_BEGIN";

export const PUSH_REDIRECT = "app/App/PUSH_REDIRECT";
